import React from "react";

import "./DeleteUser.css";
import DeleteUserForm from "../../../components/DeleteUserForm/DeleteUserForm";

export function DeleteUser() {
  return (
    <div>
      <DeleteUserForm />
    </div>
  );
}
